export default __webpack_public_path__ + "static/Craig (1)-eac64a3856eff41725e62fab8e1d0855.jpg";